import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const getDefaultState = () => {
  return {

  }
}

const state = getDefaultState();

const mutations = {
    set (state, [variable, value]){
      try {
        let temp = JSON.stringify(value);
        // localStorage.setItem(Vue.prototype.$appType + variable, temp);
        state[variable] = value;
      } catch {
        return false;
      }
    },
    setDefaultState(state){
      Object.assign(state, getDefaultState());
    }
}

export default new Vuex.Store({
    state,
    mutations
})
